module.exports = __webpack_public_path__ + "img/katarina_kitchen_7.e0ef6eea.jpg";